import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "relative flex text-black mt-2 max-w-[100%] flex-row"
};
const _hoisted_2 = ["onUpdate:modelValue", "disabled", "onKeydown", "onInput"];
import { ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LetterInput',
  props: /*#__PURE__*/_mergeModels({
    disabled: {
      type: Boolean
    },
    inputLength: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, {
    expose: __expose
  }) {
    const letter_input_refs = ref([]);
    const model = _useModel(__props, "modelValue");
    const props = __props;
    __expose(props);
    const letters = ref(Array.from({
      length: Number(props.inputLength)
    }, () => {
      return {
        value: ""
      };
    }));
    let now_value = "";
    function onChangeSingleLetter(index_letter) {
      let letter = letters.value[index_letter].value;
      let input = letter_input_refs.value[index_letter];
      let total_letters = "";
      for (let l of letters.value) {
        total_letters += l.value;
      }
      if (letter.length == 1) {
        var _letter_input_refs$va;
        if (index_letter != letters.value.length - 1) {
          input === null || input === void 0 ? void 0 : input.blur();
        }
        (_letter_input_refs$va = letter_input_refs.value[index_letter + 1]) === null || _letter_input_refs$va === void 0 ? void 0 : _letter_input_refs$va.focus();
      } else if (letter.length > 1) {
        var _letter_input_refs$va2;
        if (index_letter != letters.value.length - 1) {
          letters.value[index_letter + 1].value = letter.substring(1, 2);
          input === null || input === void 0 ? void 0 : input.blur();
        }
        letters.value[index_letter].value = letter.substring(0, 1);
        (_letter_input_refs$va2 = letter_input_refs.value[index_letter + letter.length]) === null || _letter_input_refs$va2 === void 0 ? void 0 : _letter_input_refs$va2.focus();
      } else {
        var _letter_input_refs$va3;
        if (index_letter != 0) {
          input === null || input === void 0 ? void 0 : input.blur();
        }
        (_letter_input_refs$va3 = letter_input_refs.value[index_letter - 1]) === null || _letter_input_refs$va3 === void 0 ? void 0 : _letter_input_refs$va3.focus();
      }
      total_letters = "";
      for (let l of letters.value) {
        total_letters += l.value;
      }
      now_value = total_letters;
      model.value = total_letters;
    }
    watch(model, (now, _) => {
      if (now != now_value) {
        letters.value.forEach((_, index) => {
          if (index < now.length) {
            letters.value[index].value = now.substring(index, index + 1);
          } else {
            letters.value[index].value = "";
          }
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(letters.value, (letter, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("input", {
          "onUpdate:modelValue": $event => letter.value = $event,
          disabled: _ctx.disabled,
          onKeydown: event => {
            if (letter.value == '' && event.key === 'Backspace') {
              onChangeSingleLetter(index);
            }
          },
          onInput: $event => onChangeSingleLetter(index),
          ref_for: true,
          ref_key: "letter_input_refs",
          ref: letter_input_refs,
          type: "text",
          class: "min-w-0 flex-1 text-sm mr-0 md:mr-2 text-center border-gray-200 md:text-xl focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
        }, null, 40, _hoisted_2)), [[_vModelText, letter.value]]);
      }), 256))]);
    };
  }
});